import Grid from "../Grid/grid";
import Process from "../process";
import Title from "../title";
import uiUxDesignProcessData from "./data/ui-ux-design-process-data";
import contentImage from "../../Assets/image/services-pages-images/ui-ux/ui-ux-content.webp";

function UiUxDesignProcess() {
  return (
    <section className="w-full min-h-screen h-full relative flex flex-col overflow-hidden p-2 lg:p-16">
      <Grid size={100} direction="top-left" />
      <div className="z-10 flex justify-start items-start mb-12 w-full">
        <Title title="our process" />
      </div>
      <Process
        data={uiUxDesignProcessData}
        img={contentImage}
        title="UI/UX Design"
        description="Building Scalable & High-Performance Web Apps – Ruby on Rails Solutions Tailored for Your Success."
      />
    </section>
  );
}

export default UiUxDesignProcess;
